import { z } from 'zod';
/** POST /auth/launch (unified-access.md section 3). */
export const launchSchema = z.object({ code: z.string().min(1) });
export const sessionUserSchema = z.object({
    id: z.string(),
    name: z.string(),
    username: z.string(),
});
export const sessionBranchSchema = z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
});
export const sessionResponseSchema = z.object({
    user: sessionUserSchema,
    branch: sessionBranchSchema,
    services: z.array(z.string()),
    /** Absolute session expiry, ISO (unified-access.md section 3.1). */
    expiresAt: z.iso.datetime({ offset: true }),
    /**
     * Time left on the session when this answer was built. The web app counts
     * it from when the answer arrived, so a wrong device clock does not matter.
     */
    expiresInMs: z.number().int().nonnegative(),
});
//# sourceMappingURL=contract.js.map